/**
 * In this file use to contains the physician Module Development screen UI and Logic
 **/
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { checkMilestoneAnswer } from "./../../services/UtilsService";
import ViewDevelopmentImage from "../modals/ViewDevelopmentImage";
import { useTranslation } from 'react-i18next';

//Shared Development Table View
const Development = ({ data, bodyWidth }) => {
  //Intial state declaration
  const masterDevelopment = useSelector((state) => state?.development);
  const [tab, setTab] = useState(1);
  const [missed, setMissed] = useState([]);
  const [filterData, setFilter] = useState([]);
  const [modal, setModal] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const role = Number(localStorage.getItem('role'));
  const { t } = useTranslation();
  const currentLang = localStorage.getItem('i18nextLng');

  //Initialize function
  useEffect(() => {
    if (data.length !== 0) {
      setIsLoading(true);
      try{
        var a = data.filter((x) => parseInt(x.age_range) === tab);
      if (a.length !== 0) {
        var b = a.map((i) => i.questions);
        //setFilter(b[0]);
        var c = b[0].filter((x) => x.age !== tab);
        if (c.length !== 0) {
          const result = c.map((obj) => {
            const question = masterDevelopment.questions.find(
              (item) => item.id === obj.id
            );
            const stage = masterDevelopment.stages.find(
              (item) => item.id === question.development_stage
            );
            const age = masterDevelopment.ages.find(
              (item) => item.id === question.age_range
            );

            return {
              ...obj,
              stage: question?.development_stage,
              stage_name: currentLang === 'ta' ? stage?.name_tamil || stage?.name : stage?.name,
              age_name: currentLang === 'ta' ? age?.name_tamil || age?.name : age?.name,
              question: currentLang === 'ta' ? question?.question_tamil || question?.question : question?.question,
            };
          });

          const uniqueAges = {};
          for (const entry of result) {
            const { age, age_name, ...rest } = entry;
            if (uniqueAges.hasOwnProperty(age)) {
              uniqueAges[age].values.push(rest);
            } else {
              uniqueAges[age] = {
                age,
                age_name,
                values: [rest],
              };
            }
          }
          const results = Object.values(uniqueAges);
          setMissed(results);
        } else {
          setMissed([]);
        }
        setFilter(b[0]);
      } else {
        setMissed([]);
        setFilter([]);
      }
      }catch(e){
        console.error('Error processing data:', e);
      }finally{
        setIsLoading(false); 
      }
    }
  }, [data, tab, masterDevelopment]);

  //callback function
  const handleClose = () => setModal({});

  //Bind the question value
  const getLocalizedQuestion = (question) => {
    if (currentLang === 'ta') {
      return question.question_tamil || question.question; // fallback if tamil not present
    }
    return question.question;
  };

  //Bind the age value
  const getLocalizedAge = (age) => {
    if (currentLang === 'ta') {
      return age.name_tamil || age.name; // fallback if tamil not present
    }
    return age.name;
  };

   //Bind the stage value
  const getLocalizedStage = (stage) => {
    if (currentLang === 'ta') {
      return stage.name_tamil || stage.name; // fallback if tamil not present
    }
    return stage.name;
  };

  return (
    <div className="row">
      {/*ViewDevelopmentImage Modal*/}
      {Object.keys(modal).length !== 0 && modal.status && (
        <ViewDevelopmentImage data={modal} handleClose={handleClose} />
      )}
      <div
        className={`col-xxl-12 ${role === 4 ? 'admin-table-responsive' : ''}`}
        style={{ maxWidth: "100%", overflowX: "auto" }}
      >
        <div
          className={`profile-info developement-info ${role === 4 ? 'admin-profile-info' : ''}`}
          style={{ width: bodyWidth ? bodyWidth : "100%" }}
        >
          <ul className="nav nav-pills nav-fill mb-4">
            {/* Dynamic loading Development Ages */}
            {masterDevelopment &&
              masterDevelopment.length !== 0 &&
              masterDevelopment.ages.length !== 0 &&
              masterDevelopment.ages.map((age, i) => (
                <li
                  key={i}
                  onClick={() => setTab(age.id)}
                  className="nav-item"
                  role="presentation"
                >
                  <span
                    className={
                      tab === age.id ? "nav-link py-1 active" : "nav-link py-1 "
                    }
                    type="button"
                  >
                    {getLocalizedAge(age)}
                  </span>
                </li>
              ))}
          </ul>
          <div className="tab-content">
            <div className={`table-responsive ${role === 4 ? 'admin-table-responsive' : ''}`}>
              {/* To load the actual milestone details */}
              <table className="table table-borderless theme-table">
                <tbody>
                  {/* Dynamic loading Development Stages */}
                  {filterData &&
                    filterData.length !== 0 &&
                    masterDevelopment &&
                    masterDevelopment.length !== 0 &&
                    masterDevelopment.stages.length !== 0 &&
                    masterDevelopment.stages.map((stage, i) => (
                      <tr key={i}>
                        <td className="fw-bold">{getLocalizedStage(stage)}</td>
                        <td className="fw-bold">
                          {/* Dynamic loading Development Questions */}
                          {masterDevelopment &&
                            masterDevelopment.length !== 0 &&
                            masterDevelopment.questions.length !== 0 &&
                            masterDevelopment.questions.map(
                              (question, i) =>
                                question.development_stage === stage.id &&
                                question.age_range === tab && (
                                  <p key={i} className="mb-0">
                                    {getLocalizedQuestion(question)}
                                    {question.image && (
                                      <i
                                        className="fa-solid fa-image"
                                        style={{
                                          color: "#0991FC",
                                          cursor: "pointer",
                                          marginLeft: "10px",
                                          marginRight: "5px",
                                        }}
                                        onClick={() =>
                                          setModal({
                                            status: true,
                                            title: `${t('common.motor')}`,
                                            image: question.image,
                                            question: getLocalizedQuestion(question)
                                          })
                                        }
                                      ></i>
                                    )}
                                    {checkMilestoneAnswer(
                                      tab,
                                      question.id,
                                      filterData
                                    )}
                                  </p>
                                )
                            )}
                        </td>
                      </tr>
                    ))}
                  {filterData.length === 0 && (
                    <tr>
                      <td className="text-center">{t('common.noRecord')}</td>
                    </tr>
                  )}
                </tbody>
              </table>
              {/* To load the missed milestone details */}
              {missed &&
                missed.length !== 0 &&
                missed.map((item, i) => (
                  <table className="table table-borderless theme-table" key={i}>
                    <thead>
                      <tr>
                        <th className="missedMiles">
                          {t('common.missedMilestones')} ({item.age_name})
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {item.values &&
                      // Sort item.values based on item.values.id
                      item.values.sort((a, b) => a.id - b.id)
                      .map((itm, idx) => (
                          <tr key={idx}>
                            <td className="fw-bold" style={{ width: "32%" }}>
                              {itm.stage_name}
                            </td>
                            <td>
                              <p className="mb-0">
                                {itm.question}
                                {masterDevelopment.questions.length !== 0 &&
                                  masterDevelopment.questions.map(
                                    (question, i) =>
                                      question.development_stage ===
                                        itm.stage &&
                                      question.id === itm.id && (
                                        <span key={i} className="mb-0">
                                          {question.image && (
                                            <i
                                              className="fa-solid fa-image"
                                              style={{
                                                color: "#0991FC",
                                                cursor: "pointer",
                                                marginLeft: "10px",
                                                marginRight: "5px",
                                              }}
                                              onClick={() =>
                                                setModal({
                                                  status: true,
                                                  title: `${t('common.motor')}`,
                                                  image: question.image,
                                                  question: getLocalizedQuestion(question),
                                                })
                                              }
                                            ></i>
                                          )}
                                        </span>
                                      )
                                  )}
                                {checkMilestoneAnswer(tab, itm.id, filterData)}
                              </p>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Development;
